import { Component, OnInit } from '@angular/core';
import { Product } from '../../classes/product';
import { ProductService } from '../../services/product.service';
import { LogoSlider } from '../../../shared/data/slider';
import { GlobalobjectsService } from 'src/app/globalobjects.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  public products: Product[] = [];
  public collapse: boolean = true;
  public LogoSliderConfig: any = LogoSlider;
  ImageSrc:any;
  catname:any = '';
  constructor(public productService: ProductService, public Globalobjects:GlobalobjectsService ,private route: ActivatedRoute) { 
    this.productService.getProducts.subscribe(product => this.products = product);
  }

  ngOnInit(): void {
    this.ImageSrc = this.Globalobjects.ImageURL;

    this.route.queryParams.subscribe(params => {
      this.catname = params['category'] || '';
    });
  }
  capitalizeName(name: string): string {
    return name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }

  
get filterbyCategory() {
  // Step 1: Filter products where isPriceGroup is true
  const filteredProducts = this.products.filter(product => product.isPriceGroup);

  // Step 2: Sort products
  const SortedandfilteredProducts = this.productService.sortProducts(filteredProducts, 'sortingno');

  // Step 3: Group categories with count + categorySortingNo
  const categoryCountMap = SortedandfilteredProducts.reduce((acc, product) => {
    if (!acc[product.type]) {
      acc[product.type] = {
        count: 0,
        categorySortingNo: product.categorySortingNo || ""   // handle empty
      };
    }
    acc[product.type].count += 1;
    return acc;
  }, {} as { [key: string]: { count: number; categorySortingNo: string } });

  // Step 4: Convert to array (without categorySortingNo)
  const returnData = Object.keys(categoryCountMap).map(category => ({
    name: category,
    count: categoryCountMap[category].count
  }));

  // Step 5: Sort by categorySortingNo (empty values go last)
  return returnData.sort((a, b) => {
    const aSort = categoryCountMap[a.name].categorySortingNo;
    const bSort = categoryCountMap[b.name].categorySortingNo;

    if (!aSort && !bSort) return 0;   // both empty
    if (!aSort) return 1;             // a empty → a goes last
    if (!bSort) return -1;            // b empty → b goes last

    return aSort.localeCompare(bSort);
  });
}


  

}
